import $ from 'jquery';
const SIZE_GUIDE = '#js-size-guide';
const SIZE_GUIDE_CLOSE = '.js-size-guide-close';
const SIZE_GUIDE_ITEM = '.SizeGuide-item';
export const init = async function() {
    // show size guide
    $(document).on('click', SIZE_GUIDE, ()=>{
        $('#js-size-guide-modal').fadeIn();
        $('#js-size-guide-overflow').fadeIn();
    });
    // hide size guide
    $(document).on('click', SIZE_GUIDE_CLOSE, ()=>{
        $('#js-size-guide-modal').fadeOut();
        $('#js-size-guide-overflow').fadeOut();
    });
    // change items
    $(document).on('click', SIZE_GUIDE_ITEM, (pos)=>{
        const item = $(pos.target).attr('size-nav');
        $('.SizeGuide-item').removeClass('active').attr('aria-selected', 'false').attr('tabindex', '-1');
        $('.SizeGuide-body').removeClass('active');
        $('.SizeGuide-item[size-nav="' + item + '"]').addClass('active').attr('aria-selected', 'true').attr('tabindex', '0');
        $('.SizeGuide-body[size-body="' + item + '"]').addClass('active');
    });
    //KEYBOARD USER
    // show size guide
    $(document).on('keyup', SIZE_GUIDE, (e)=>{
        if (e.keyCode === 13) {
            $('#js-size-guide-modal').fadeIn();
            $('#js-size-guide-overflow').fadeIn();
            $('.js-size-guide-close').focus();
        }
    });
    // hide size guide
    $(document).on('keyup', SIZE_GUIDE_CLOSE, (e)=>{
        if (e.keyCode === 13) {
            $('#js-size-guide-modal').fadeOut();
            $('#js-size-guide-overflow').fadeOut();
        }
    });
    // change items
    $(document).on('keyup', SIZE_GUIDE_ITEM, (pos)=>{
        if (pos.keyCode === 13) {
            const item = $(pos.target).attr('size-nav');
            $('.SizeGuide-item').removeClass('active').attr('aria-selected', 'false').attr('tabindex', '-1');
            $('.SizeGuide-body').removeClass('active').attr('hidden', '');
            $('.SizeGuide-item[size-nav="' + item + '"]').addClass('active').attr('aria-selected', 'true').attr('tabindex', '0');
            $('.SizeGuide-body[size-body="' + item + '"]').addClass('active').removeAttr('hidden');
        }
    });
};
